export default __webpack_public_path__ + "static/typescript-52943e0566e82987de8973864653ce8c.png";